export default {
  "nav.home": "首页",
  "nav.movies": "电影",
  "nav.tv": "电视剧",
  "nav.variety": "综艺",
  "nav.anime": "动漫",
  "nav.articles": "影视资讯",
  "nav.about": "关于我们",
  "nav.search": "搜索影片...",
  "hero.title": "蜜桃影视",
  "hero.subtitle": "海量高清影视，随时随地畅享观影",
  "hero.cta": "开始探索",
  "hero.search_placeholder": "搜索你喜欢的电影、电视剧...",
  "section.featured": "热门推荐",
  "section.categories": "分类浏览",
  "section.news": "最新影视资讯",
  "section.faq": "常见问题",
  "category.movies": "电影",
  "category.tv": "电视剧",
  "category.variety": "综艺",
  "category.anime": "动漫",
  "category.all": "全部",
  "breadcrumb.home": "首页",
  "footer.about": "蜜桃影视致力于为用户提供海量高清影视资源，涵盖电影、电视剧、综艺、动漫等丰富内容，打造极致的在线观影体验。",
  "footer.quick_links": "快速链接",
  "footer.contact": "联系我们",
  "footer.copyright": "© 2026 蜜桃影视 版权所有",
  "footer.email": "contact@mitaomovies.com",
  "footer.phone": "400-888-9999",
  "read_more": "阅读全文",
  "view_all": "查看全部",
  "no_content": "暂无内容",
  "back_to_home": "返回首页",
  "loading": "加载中...",
  "article.related": "相关推荐",
  "article.published": "发布时间",
  "article.author": "作者",
  "article.views": "阅读量",
  "about.title": "关于蜜桃影视",
  "about.brand_story": "品牌故事",
  "about.advantages": "平台优势",
  "about.contact_us": "联系我们",
}